import { first } from "lodash"
import config from "react-global-configuration"

import { Answer, Value } from "containers/Survey/types"
import { PATH } from "models/survey/_paths"
import { FOR_PATIENT } from "models/survey/constants"
import { Call, OpticConsultationRequest, ResponsePrice } from "types/payload"
import { Action, ActionWithoutPayload, Message } from "types/redux"

import { PAYMENT_REQUIRES_ACTION, PRICE_SUCCESS, PRICE_REQUEST, PRICE_ERROR, PRICE_EXEMPTED, RESET_PAYMENT_STORE, SETUP_PAYMENT_INTENT_REQUEST, TLC_ERROR, TLC_REQUEST, TLC_SUCCESS } from "./constants"
import { DoctorType } from "types/entity"

const actions = {
  reset: (): ActionWithoutPayload => ({ type: RESET_PAYMENT_STORE }),
  submit: (answers?: Answer[]): Action<OpticConsultationRequest> => {
    if (!answers)
      return { type: TLC_REQUEST, payload: { ...config.get("mock.get.call") } }

    const complyResponse = (wantedId: string): Value | undefined => {
      const responses: Value[] | undefined =
        answers.find(({ questionId }) => questionId === wantedId)?.value ||
        undefined
      if (!responses) return undefined
      const complied =
        responses.length > 1 ? responses.join(", ") : first(responses)

      return complied
    }

    const selectedPatientId = complyResponse(PATH.patient)

    const payload: OpticConsultationRequest = {
      ...config.get("mock.call"),
      relative_id:
        selectedPatientId === FOR_PATIENT ? undefined : selectedPatientId,
      anamnesis: {
        ophtalmologic_background: complyResponse(PATH.optic_illness),
        ophtalmologic_background_details: complyResponse(
          PATH.optic_illness_details
        ),
        illness: complyResponse(PATH.illness),
        illness_details: complyResponse(PATH.illness_details),
        reason: complyResponse(PATH.reason),
        reason_details: complyResponse(PATH.reason_details),
        contact_lens_type: complyResponse(PATH.contact_lens_type),
        contact_lens_brand: complyResponse(PATH.contact_lens_brand),
        contact_lens_bending_radius: complyResponse(PATH.contact_lens_bending_radius),
        contact_lens_diameter: complyResponse(PATH.contact_lens_diameter),
      },
      payment: {
        exemption: complyResponse("exemption") || false,
      },
      payment_method_id: complyResponse("payment_method_id"),
      payment_intent_id: complyResponse("payment_intent_id"),
      payment_sheet_intent_id: complyResponse('payment_sheet_intent_id'),
      share_personal_data: complyResponse(PATH.consent),
      carer_guid: complyResponse(PATH.selected_carer),
    }
    return {
      type: TLC_REQUEST,
      payload,
    }
  },

  error: (error: string): Action<Message> => ({
    type: TLC_ERROR,
    payload: { text: error || "Impossible de lancer la TLC", type: "error" },
  }),

  success: (payload: Call): Action<Call> => ({
    type: TLC_SUCCESS,
    payload,
  }),
  paymentRequiresAction: (
    payment_intent_client_secret: string
  ): Action<string> => ({
    type: PAYMENT_REQUIRES_ACTION,
    payload: payment_intent_client_secret,
  }),
  priceRequest: (payload: {
    relativeId?: string
    callTypeValue?: DoctorType
  }): Action<{ relativeId?: string, callTypeValue?: DoctorType }> => ({
    type: PRICE_REQUEST,
    payload,
  }),
  priceError: (payload: string): Action<Message> => ({
    type: PRICE_ERROR,
    payload: { type: "error", text: payload },
  }),
  priceSuccess: (payload: { ophtalmologist: ResponsePrice }): Action<{ ophtalmologist: ResponsePrice }> => ({
    type: PRICE_SUCCESS,
    payload,
  }),
  priceExempt: (payload: boolean): Action<boolean> => ({
    type: PRICE_EXEMPTED,
    payload,
  }),
  createPaymentIntent: (): ActionWithoutPayload => ({
    type: SETUP_PAYMENT_INTENT_REQUEST,
  })
}

export default actions
